import { useEffect } from "react";
import { useUser, User } from "./useUser";
import { useLocalStorage } from "./useLocalStorage";

export const useAuth = () => {
  const { user, addUser, removeUser, setUser } = useUser();
  const { getItem } = useLocalStorage();

  useEffect(() => {
    const loadUser = async () => {
      const storedUser = await getItem("user");
      if (storedUser) {
        addUser(JSON.parse(storedUser),()=>{});
      }
    };
    loadUser();
  }, [addUser, getItem]);

  const login = (user: User, callback: () => void) => {
    console.log(user, 'user');
    addUser(user, callback);
  };

  const logout = () => {
    removeUser();
  };

  return { user, login, logout, setUser };
};
